export const SET_STATE = 'logger/SET_STATE';
export const PUSH_TO_QUEUE = 'logger/PUSH_TO_QUEUE';
export const SHIFT_QUEUE = 'logger/SHIFT_QUEUE';
export const RESET_STATE = 'logger/RESET_STATE';
